document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('slider-component');

  sliders.forEach(slider => {
    const sliderTrack = slider.querySelector('ul.slider');
    const sliderButtons = slider.querySelector('.slider-buttons');

    if (!sliderTrack || !sliderButtons) return;

    // Wait for all images/fonts/layout to load if needed
    requestAnimationFrame(() => {
      const contentWidth = sliderTrack.scrollWidth;
      const visibleWidth = sliderTrack.clientWidth;

      if (contentWidth <= visibleWidth) {
        sliderButtons.style.setProperty('display', 'none', 'important'); // Hide buttons if all slides are visible
      } else {
        sliderButtons.style.display = ''; // Show buttons otherwise
      }
    });
  });
});
